import { IPaginationFilteredResponse } from '@mg-platform/core/core-feature'
import { IBaseUser, OrganizationFeatures } from '@mg-platform/users/users-data-access'

export interface IUpdateOrganizationRequest {
  paidShops?: number
  notes?: string
  subscriptionExpireDate?: Date
  featurePermissions?: OrganizationFeatures[]
  isBlocked?: boolean
}

export interface IOrganizationBase {
  id: string
  name: string
  createdById: string
  created: Date
  notes: string
  subscriptionExpireDate: Date
  paidShops?: number
  isBlocked?: boolean
}

export interface IOrganizationItem extends IOrganizationBase {
  numberOfMembers: number
  numberOfShops: number
  numberOfGroups: number
  lastReportDate?: Date
  lastLoginDate?: Date
}

export interface IAllOrganizationsResponse extends IPaginationFilteredResponse {
  organizations: IOrganizationItem[]
}

export interface IOrganizationDetails extends IOrganizationBase {
  membersCount: number
  shopsCount: number
  groupsCount: number
  features?: OrganizationFeatures[]
  creator?: IBaseUser
}
